module.exports = __webpack_public_path__ + "json/buildings-0.json?f6bbc394a1a491d8b1aa1df48e8c3533";


//////////////////
// WEBPACK FOOTER
// ./src/assets/packed/buildings/buildings-0.json
// module id = 1714
// module chunks = 3